<template>
  <li>
    <div class="col-md-12 outside">
      <div class="mystyle">
        <div class="row margin10">
          <div class="form-group test">
            <input
              type="date"
              name=""
              v-model="payment.time_begin"
              class="inputstylesmall"
            />
            <span>到</span>
            <input
              type="date"
              name=""
              v-model="payment.time_until"
              :min="payment.time_begin"
              class="inputstylesmall"
              required=""
            />
            <span>止</span>
          </div>
        </div>
        <div class="row margin10">
          <div class="form-group">
            <label class="control-label col-md-2 col-sm-2 col-xs-12">
              每個月費/月
              <span>*</span>
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12" v-if="!editFeeBlock">
              <input
                :disabled="editFeeBlock"
                v-model="payment.service_fee"
                type="number"
                min="0"
                class="col-md-12 inputstylesmall"
                placeholder="月費"
                :required="!editFeeBlock"
              />
            </div>
            <label class="control-label col-md-2 col-sm-2 col-xs-12">
              出班費/班
              <span>*</span>
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12" v-if="!editFeeBlock">
              <input
                :disabled="editFeeBlock"
                v-model="payment.fee_per_shift"
                type="number"
                min="0"
                class="col-md-12 inputstylesmall"
                placeholder="出班費"
                :required="!editFeeBlock"
              />
            </div>
          </div>
        </div>
        <div class="row margin10">
          <div class="form-group" v-if="showOverShiftBlock">
            <label class="control-label col-md-2 col-sm-2 col-xs-12">
              超過/次數
              <span>*</span>
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <input
                v-model="payment.shift_limit"
                type="number"
                min="1"
                class="col-md-12 inputstylesmall"
                placeholder="限定次數"
                :required="shiftLimitRequired"
              />
            </div>
            <label class="control-label col-md-2 col-sm-2 col-xs-12">
              每班車資/元
              <span>*</span>
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <input
                v-model="payment.fee_per_over_shift_limit"
                type="number"
                min="1"
                class="col-md-12 inputstylesmall"
                placeholder="每班車資"
                :required="feePerOverShiftLimitRequired"
              />
            </div>
          </div>
        </div>
        <div class="row margin10">
          <div class="form-group">
            <label class="control-label col-md-2 col-sm-2 col-xs-12">
              乘客險月費
              <span>*</span>
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <input
                v-model="payment.insurance_for_user"
                type="number"
                class="col-md-12 inputstylesmall"
                placeholder="乘客險月費"
              />
            </div>
            <label
              class="control-label col-md-2 col-sm-2 col-xs-12"
              v-if="editFareCommission"
            >
              車資比例
              <span>*</span>
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12" v-if="editFareCommission">
              <input
                :disabled="!editFareCommission"
                min="1"
                v-model="payment.fare_commission"
                type="number"
                class="col-md-12 inputstylesmall"
                placeholder="百分比"
                :required="editFareCommission"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <h4 class="showFare fareImput">
            每個月須付${{ payment.service_fee }}，基本每班費${{
              payment.fee_per_shift
            }}，限定{{ payment.shift_limit }}班，超過限定班數，每班車資為＄{{
              payment.fee_per_over_shift_limit
            }}，乘客險月費＄{{ payment.insurance_for_user }}，車資比例{{
              payment.fare_commission
            }}％
          </h4>
        </div>
        <button
          @click="submit"
          class="btn btn-default item-btn"
          type="button"
          name="button"
        >
          新增繳費單
        </button>
      </div>
    </div>
  </li>
</template>

<script>
import moment from 'moment'
export default {
  props: ['data'],
  data() {
    return {
      payment: {
        time_begin: moment().format('YYYY-MM-DD'),
        time_until: null,
        service_fee: null,
        fee_per_shift: null,
        shift_limit: null,
        fee_per_over_shift_limit: null,
        insurance_for_user: null,
        fare_commission: null,
      },
      date_max: moment().endOf('month').format('YYYY-MM-DD'),
    }
  },
  computed: {
    showOverShiftBlock: function () {
      //   console.log(parseInt(this.payment.service_fee), typeof(parseInt(this.payment.service_fee)));
      //   return this.payment.service_fee > -1 && (this.payment.fee_per_shift)
      return this.payment.service_fee > 0 && this.payment.fee_per_shift > 0
    },
    editFareCommission: function () {
      //   return this.payment.service_fee != null && this.payment.service_fee != '' ||
      //     this.payment.fee_per_shift !== null && this.payment.fee_per_shift !== ''
      // console.log(this.payment.fee_per_shift=== '0')
      return this.payment.fee_per_shift === '0'
    },
    editFeeBlock: function () {
      //   console.log((this.payment.fare_commission));
      //   return this.payment.fare_commission != null && this.payment.fare_commission != ''
      return false
    },
    shiftLimitRequired: function () {
      return (
        this.payment.fee_per_over_shift_limit != null &&
        this.payment.fee_per_over_shift_limit != ''
      )
    },
    feePerOverShiftLimitRequired: function () {
      return this.payment.shift_limit != null && this.payment.shift_limit != ''
    },
  },
  methods: {
    submit() {
      console.log(this.payment.time_until)
      if (this.payment.time_until === null) {
        alert('選擇日期')
      }

      var count = 0
      for (var i = 0; i < this.data.length; i++) {
        // console.log('XXXXXXX',this.data[i])
        /*
            A: this.data[i].time_begin (原本初始時間)
            B: this.data[i].time_until (原本中止時間)
            C: this.payment.time_begin (新初始時間)
            D: this.payment.time_until (新中止時間)
            */
        //    console.log(this.payment.time_begin+"----"+this.data[i].timeBegin+"----"+this.payment.time_until+"-----"+this.data[i].timeUntil)
        if (
          moment(this.payment.time_begin).isSame(this.data[i].timeBegin) ||
          moment(this.payment.time_begin).isSame(this.data[i].timeUntil)
        ) {
          //    console.log(moment(this.payment.time_begin).isSame(this.data[i].timeBegin)+"  "+moment(this.payment.time_begin).isSame(this.data[i].timeUntil))

          count += 1
        }

        if (
          moment(this.payment.time_until).isSame(this.data[i].timeBegin) ||
          moment(this.payment.time_until).isSame(this.data[i].timeUntil)
        ) {
          //    console.log(moment(this.payment.time_until).isSame(this.data[i].timeBegin)+"  "+moment(this.payment.time_until).isSame(this.data[i].timeUntil))

          count += 1
        }
        //已有繳費日期內
        if (
          moment(this.payment.time_begin).isBetween(
            this.data[i].timeBegin,
            this.data[i].timeUntil,
          ) ||
          moment(this.payment.time_until).isBetween(
            this.data[i].timeBegin,
            this.data[i].timeUntil,
          )
        ) {
          count += 1
        }
        // 新增繳費日期涵蓋所有繳費單
        if (
          moment(this.data[i].timeBegin).isBetween(
            this.payment.time_begin,
            this.payment.time_until,
          ) ||
          moment(this.data[i].timeUntil).isBetween(
            this.payment.time_begin,
            this.payment.time_until,
          )
        ) {
          count += 1
        }
        //C<A; D<A
        // if (!moment(this.payment.time_begin).isBefore(this.data[i].timeBegin) && moment(this.payment.time_until).isBefore(this.data[i].timeBegin)&&!moment(this.data[i].timeUntil).isBefore(this.payment.time_begin) && moment(this.data[i].timeUntil).isBefore(this.payment.time_until)){
        //     console.log(moment(this.data[i].timeUntil).isBefore(this.payment.time_begin))
        //     console.log(moment(this.data[i].timeUntil).isBefore(this.payment.time_until))
        //     console.log('---------->(4)')

        //     count +=1
        // }
        //B<C; B<D
      }
      // console.log(this.data.length)
      // console.log(count)
      if (count === 0) {
        this.$emit('submit-payment', this.payment)
      } else {
        alert('日期有重複')
        return
      }
    },
  },
}
</script>

<style scoped>
.outside {
  border: solid 2px;
  margin-bottom: 10px;
}
.test {
  display: inline-block;
}
.mystyle {
  margin: 10px;
}
.item-title {
  font-size: 16px;
  margin: 5px;
}
.item-btn {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/AddPaymentItem.vue